import Spinner from './Spinner';

export const MatrixUpdatingCard = () => {
	return (
		<div
			className="fixed inset-0 z-50 flex items-center justify-center bg-black/20"
			style={{ width: '100vw', height: '100vh' }}
		>
			<div className="flex items-center gap-3 rounded-lg bg-white px-6 py-4 shadow-lg">
				<Spinner size={24} />
				<span className="text-sm font-medium text-gray-700">
					Atualizando a matriz...
				</span>
			</div>
		</div>
	);
};
